/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Err_Source_DupInputs */

const vi_scl_new_err_source_dup = /** @type {(inputs: Scl_New_Err_Source_DupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô nguồn đã được chọn ở dòng khác`)
};

/**

* @param {Scl_New_Err_Source_DupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_err_source_dup = /** @type {((inputs?: Scl_New_Err_Source_DupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Err_Source_DupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_err_source_dup(inputs)
});